import Dialog from '@/js/components/Dialog'

export default class DialogContactUs extends Dialog {
    name = 'contact-us-success'

    render() {
        if (this.el) {
            return
        }

        const template = document.getElementById(`dialog-${this.name}`)

        if (!template) {
            console.error('Template not found')
            return
        }

        const dialog = template.content.firstElementChild

        super.render(dialog)
    }
}
